import React, { useContext, useState } from "react";
import { CardTracking } from "../CardTracking";
import { Button, Loader, Paragraph } from "@sicredi/react";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import { PAGE } from "#/constants";
import { ITrackingComponents } from "../model";
import {
  downloadFilePDF,
  getValorDecodeBase64,
  handleDetalhesContrato,
  toastErrorMenssage,
} from "#/contextProver/ContextProverServices";
import { ContextAPI } from "#/contextProver/ContextProver";
import { ButtonLinkChevronRight } from "#/components/ButtonLinkChevronRight";
import { vendasAssinarContrato } from "#/api/vendasAssinarContrato";
import { getVendasListaProposta } from "#/api/getVendasListaProposta";

export const AssinaturaContratoTracking: React.FC<ITrackingComponents> = ({
  paragraphSize,
  isIconWarning,
  isContratoGerado,
  isAssinaturaVencida,
  state,
}) => {
  const {
    agencyAccountCommissioned,
    codigoComissionado,
    idDocumento,
    documento,
    setVendasContrato,
    setVendasListaProposta,
  } = useContext(ContextAPI);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const isUnlocked = !isContratoGerado && !isAssinaturaVencida && !state;

  const handleContrato = async () => {
    try {
      const vendasContrato = await handleDetalhesContrato({
        conta: getValorDecodeBase64(agencyAccountCommissioned.conta),
        codigoComissionado,
        idDocumento,
        cooperativa: getValorDecodeBase64(agencyAccountCommissioned.agencia),
        documento,
        setIsLoading,
        setVendasContrato,
      });
      if (vendasContrato) {
        const base64DataFile = vendasContrato.data.contract;
        downloadFilePDF({ base64DataFile, nameFile: "contrato_consorcio" });
      }
    } catch {
      toastErrorMenssage();
    }
  };

  const handleSignatureButton = async () => {
    if (!isAssinaturaVencida && isContratoGerado) {
      return navigate(PAGE.CONTRATO);
    }

    try {
      setIsLoading(true);
      await vendasAssinarContrato({
        codigoComissionado,
        idDocumento,
        conta: getValorDecodeBase64(agencyAccountCommissioned.conta),
        cooperativa: getValorDecodeBase64(agencyAccountCommissioned.agencia),
        documento,
      });

      const vendasListaProposta = await getVendasListaProposta({
        codigoComissionado,
        documento,
      });
      setVendasListaProposta(vendasListaProposta);
      navigate(PAGE.CONTRATO);
    } catch {
      toastErrorMenssage();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Loader show={isLoading} fullScreen />
      <CardTracking
        title="Assinatura de Contrato"
        state={state}
        isIconWarning={isIconWarning && !state}
        isIconExclamationBlue={isUnlocked}
      >
        {!state && (
          <>
            <Paragraph size={paragraphSize(state)} weight="normal">
              Seu contrato está pronto. Assine e prossiga para etapa de
              pagamento.
            </Paragraph>

            <div className={styles.button_container}>
              <Button
                onClick={handleSignatureButton}
                appearance="primary"
                className={styles.button_primary}
              >
                Assinar contrato
              </Button>
            </div>
          </>
        )}

        {state && (
          <>
            <Paragraph size={paragraphSize(state)} weight="normal">
              Contrato assinado.
            </Paragraph>

            <div className={styles.button_link_container}>
              <ButtonLinkChevronRight
                text="Ver detalhes do contrato"
                onClick={handleContrato}
              />
            </div>
          </>
        )}
      </CardTracking>
    </div>
  );
};
